module.exports = __webpack_public_path__ + "img/hondapilot.1baca58d.png";